import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import ProfileModalContent from "./modal/ProfileModalContent";
import { profileRouterService } from "@/services/profileRouterService";
import { useNavigate } from "react-router-dom";

interface User {
  id: string;
  user_id: string;
  display_name: string;
  age: number;
  photo_urls: string[];
  bio: string;
  distance: number;
  isOnline: boolean;
  public_interests: string[];
  private_interests: string[];
}

interface ProfileModalProps {
  user: any;
  isOpen: boolean;
  onClose: () => void;
}

const ProfileModal = ({ user, isOpen, onClose }: ProfileModalProps) => {
  const navigate = useNavigate();

  const handleViewFullProfile = () => {
    const profileRoute = profileRouterService.getProfileRoute(
      user.user_id,
      user.username || user.first_name,
      user.display_name
    );
    navigate(profileRoute);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md p-0 overflow-hidden">
        <ProfileModalContent user={user} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default ProfileModal;
